import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import 'bootstrap/dist/css/bootstrap.min.css';

const $ = require('jquery');
window.$ = $;
window.jQuery = $;
require('bootstrap/dist/js/bootstrap.min');

import store from './store'
import routes from './router.js'
import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/css/iconfont.css';
import '../src/assets/css/iconfont2.css';
import '../src/assets/css/iconfont3.css';
import '../src/assets/css/custom.css';
import VueFilterDateFormat from 'vue-filter-date-format';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import scroll from 'vue-seamless-scroll'
import babelPolyfill from 'babel-polyfill'
import VueHtml2Canvas from 'vue-html2canvas';
import VueClipboard from 'vue-clipboard2'
import vueCountryRegionSelect from 'vue-country-region-select'
import VueCookies from 'vue-cookies'
import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = store.state.serverURL;
// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (err) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    const status = err.response?.status || 500;
    // we can handle global errors here
    switch (status) {
        // authentication (token related issues)
        case 401: {
            app.$message.closeAll();
            app.$message({
                type: "error",
                message: "Unauthenticated"
            });
            app.$cookies.remove('blacknova.sid');
            app.$store.state.user = null;
            
            return window.location.href = '/#/login';
        }
        // forbidden (permission related issues)
        case 403: {
            app.$message.closeAll();
            app.$message({
                type: "error",
                message: "Forbidden"
            });
            app.$cookies.remove('blacknova.sid');
            app.$store.state.user = null;

            return window.location.href = '/#/dashboard';
        }
        // generic api error (server related) unexpected
        default: {
            return Promise.reject(err);
        }
    }
});

Vue.use(VueCookies)

Vue.use(vueCountryRegionSelect)

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.use(babelPolyfill)

Vue.use(scroll, {
    componentName: 'scroll'
})
Vue.use(VueHtml2Canvas)
Vue.use(Viewer)
Viewer.setDefaults({
    Options: {
        'inline': true,
        'button': true,
        'navbar': false,
        'title': true,
        'toolbar': true,
        'tooltip': true,
        'movable': true,
        'zoomable': true,
        'rotatable': false,
        'scalable': false,
        'transition': true,
        'fullscreen': true,
        'keyboard': true,
        'url': 'data-source'
    }
})

Vue.config.productionTip = false
locale.use(lang)
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueFilterDateFormat)

const router = new VueRouter({
    routes
})

const disallowedRoutes = {
    admin: [],
    salesvp: ['managersupport', 'managernews'],
    salesmanager: ['managersupport', 'managernews'],
    distributors: ['managersupport', 'managernews'],
    distributorsmanager: ['myorders'],
    dealers: ['managersupport', 'managernews', 'myusers']
}

const DownloaderBroadCast = new BroadcastChannel(store.getters.downloaderBroadcastChannel())

router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (store.state.user != null) {
        if (disallowedRoutes[store.state.user.type].includes(to.name)) {
            next({
                name: 'dashboard'
            });
        } else {
            next();
        }
    } else {
        if (Vue.$cookies.isKey('blacknova.sid')) {
            await axios
                .post("/login", {}).then((res) => {
                    if (typeof res.data._id != 'undefined') {
                        store.state.user = res.data;
                        next();
                    } else {
                        Vue.$cookies.remove('blacknova.sid')
                        DownloaderBroadCast.close()
                        store.state.user = null
                        if (to.path.split('/')[1] == 'user' || to.path == '/login' || to.path == '/signup' || to.path == '/password' || to.path.split('/')[1] == 'collection' || to.path.split('/')[1] == 'artwork' || to.path.split('/')[1] == 'pdfPreview') {
                            next()
                        } else {
                            next({
                                name: 'login'
                            });
                        }
                    }
                })
        } else {
            Vue.$cookies.remove('blacknova.sid')
            DownloaderBroadCast.close()
            store.state.user = null
            if (to.path.split('/')[1] == 'user' || to.path == '/login' || to.path == '/signup' || to.path == '/password' || to.path.split('/')[1] == 'collection' || to.path.split('/')[1] == 'artwork' || to.path.split('/')[1] == 'pdfPreview') {
                next()
            } else {
                next({
                    name: 'login'
                });
            }
        }
    }
})


var app = new Vue({
    router,
    store,
    // i18n,
    render: h => h(App),
}).$mount('#app')